import { AnalyticsTracker } from "traclytics-js-sdk";

export const tracker = new AnalyticsTracker();

export const initializeAnalytics = (userId, department, userName) => {
  tracker.init({
    projectKey: process.env.REACT_APP_TRACLYTICS_PROJECT_KEY,
    accessToken: process.env.REACT_APP_TRACLYTICS_ACCESS_TOKEN,
    userId,
    userName,
    isHris: false,
    department: department,
    debug: process.env.NODE_ENV === "development",
    isEnable: process.env.REACT_APP_TRACLYTICS_IS_ENABLED === "true" ? true : false,
  });
};
